import { Properties } from "../properties.model";
import { LayerType, sharedForms } from "../layer.model";
import { buildingForm } from "./building.form";
import { colorOverlayForm } from "./color-overlay.form";
import { contourForm } from "./contour.form";
import { waterForm } from "./water.form";
import { EffectsType } from "../ui-effects.model";
import { outlineForm } from "../effect-properties.models/outline.form";
import { blurForm } from "../effect-properties.models/blur.form";
import { poiForm } from "./poi-glow.form";
import { materialOverlayForm } from "./material-overlay.form";
import { textureForm } from "../effect-properties.models/texture.form";
import { heightGlowForm } from "./height-glow.form";
import { roadForm } from "./road.form";
import { sepiaForm } from "../effect-properties.models/sepia.form";
import { dropShadowForm } from "../effect-properties.models/dropshadow.form";
import { gridLinesForm } from "./grid-lines.form";
import { noiseForm } from "../effect-properties.models/noise.form";
import { zonesForm } from "./zones.form";
import { baseForm } from "./base.form";

export const layerPropertyMapping: { [key in LayerType]: Properties} = {
  [LayerType.Base] : baseForm,
  [LayerType.Contour] : contourForm,
  [LayerType.Water]: waterForm,
  [LayerType.Overlay] : colorOverlayForm,
  [LayerType.Buildings] : buildingForm,
  [LayerType.POIGlow] : poiForm,
  [LayerType.MaterialOverlay] : materialOverlayForm,
  [LayerType.HeightGlow] : heightGlowForm,
  [LayerType.Roads] : roadForm,
  [LayerType.GridLines] : gridLinesForm,
  [LayerType.Zones] : zonesForm,
}

export const effectPropertiesMapping: { [key in EffectsType]: Properties} = {
  [EffectsType.Blur] : blurForm,
  [EffectsType.Texture] : textureForm,
  [EffectsType.Outline] : outlineForm,
  [EffectsType.Sepia]: sepiaForm,
  [EffectsType.DropShadow]: dropShadowForm,
  [EffectsType.Noise] : noiseForm
}

